/**
 * Тэги, которе не нужно выводить в интерфейсе,
 * но они должны оставаться в микроразметке
 * https://tasks.forbes.ru/issue/FOR-1136/Teg-seo-content
 */
export const HIDDEN_TAGS = ['tegi/seo-content', 'tegi/disklejmerbankrotstvo'];
